import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

interface Params {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  /** Defaults to next step in SIM upsell flow */
  nextPath?: string;
}

/**
 * Continue handler for preloaded SIM congratulations (post verification / API success).
 */
export function usePreloadedSimCongratulationsContinue({
  showDialog,
  setShowDialog,
  nextPath = "/activation/preloaded-sim/choose-service-plan",
}: Params) {
  const navigate = useNavigate();
  const continueTapLockRef = useRef(false);

  useEffect(() => {
    if (showDialog) {
      continueTapLockRef.current = false;
    }
  }, [showDialog, nextPath]);

  const handleContinue = useCallback(() => {
    if (continueTapLockRef.current) return;
    continueTapLockRef.current = true;
    try {
      setShowDialog(false);
      navigate(nextPath);
    } catch {
      continueTapLockRef.current = false;
    }
  }, [navigate, nextPath, setShowDialog]);

  return { handleContinue };
}
